import { render, staticRenderFns } from "./CreateOrderLogistic.vue?vue&type=template&id=b5508b94&scoped=true&"
import script from "./CreateOrderLogistic.vue?vue&type=script&lang=js&"
export * from "./CreateOrderLogistic.vue?vue&type=script&lang=js&"
import style0 from "./CreateOrderLogistic.vue?vue&type=style&index=0&id=b5508b94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5508b94",
  null
  
)

export default component.exports